import React, { useState, useEffect } from 'react';
import { Cookie, X, Shield } from 'lucide-react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after 1 second delay
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-5xl mx-auto bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 border-2 border-yellow-500/30 rounded-xl p-6 shadow-2xl backdrop-blur-sm">
        <div className="flex items-start gap-4">
          {/* Icon */}
          <div className="flex-shrink-0 w-12 h-12 bg-yellow-500/10 rounded-lg flex items-center justify-center">
            <Cookie className="w-6 h-6 text-yellow-500" />
          </div>
          
          {/* Content */}
          <div className="flex-1">
            <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2">
              Cookie Consent
              <Shield className="w-4 h-4 text-green-500" />
            </h3>
            <p className="text-gray-300 text-sm mb-4">
              We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies. Read our{' '}
              <a href="/privacy" className="text-yellow-500 hover:underline font-medium">
                Privacy Policy
              </a>
              {' '}to learn more.
            </p>
            
            {/* Buttons */}
            <div className="flex flex-wrap items-center gap-3">
              <button
                onClick={handleAccept}
                className="px-6 py-2.5 bg-yellow-500 text-black font-semibold rounded-lg hover:bg-yellow-400 transition-all transform hover:scale-105 text-sm"
              >
                Accept All Cookies
              </button>
              <button
                onClick={handleDecline}
                className="px-6 py-2.5 bg-gray-700 text-white font-medium rounded-lg hover:bg-gray-600 transition-colors text-sm"
              >
                Decline
              </button>
              <a
                href="/privacy"
                className="px-4 py-2.5 text-gray-400 hover:text-white transition-colors text-sm"
              >
                Learn More
              </a>
            </div>
          </div>
          
          {/* Close Button */}
          <button
            onClick={handleDecline}
            className="flex-shrink-0 text-gray-400 hover:text-white transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
